import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
};

const lineItemSlice = createSlice({
  name: "lineItem",
  initialState,
  reducers: {
    addItem: (state, { payload }) => {
      state.data.push(payload); // Create
    },
    updateItem: (state, { payload }) => {
      const index = state.data.findIndex((item) => item.id === payload.id);
      if (index !== -1) {
        state.data[index] = payload; // Update
      }
    },
    deleteItem: (state, { payload }) => {
      state.data = state.data.filter((item) => item.id !== payload); // Delete
    },
    setItems: (state, { payload }) => {
      state.data = payload; // Read
    },
  },
});

export const { addItem, updateItem, deleteItem, setItems } =
  lineItemSlice.actions;
export default lineItemSlice.reducer;
